import { useTranslation } from 'react-i18next';

const SelectStep = () => {
  const { t } = useTranslation(['overruleCustomsLight']);

  return (
    <>
      <div>
        <p>{t('overruleCustomsLight:sidebarSelectContainers.stepFlavorText')}</p>
        <p>{t('overruleCustomsLight:sidebarSelectContainers.beAwareText')}</p>
      </div>
    </>
  );
};

export default SelectStep;
